import type { AppRoute } from './app-router';
import type { Session } from './contracts';

export function protectedRedirect(route: AppRoute, session: Session | null): string | null {
  if (
    (route.kind === 'dashboard' || route.kind === 'editor' || route.kind === 'onboarding') &&
    !session
  ) {
    let target =
      route.kind === 'editor'
        ? `/editor/${encodeURIComponent(route.siteId)}`
        : route.kind === 'onboarding'
          ? '/onboarding'
          : '/dashboard';
    if (route.kind === 'editor' && route.preview) target += '?preview=1';
    if (route.kind === 'dashboard') {
      const query = new URLSearchParams();
      if (route.section) query.set('section', route.section);
      if (route.workspaceId) query.set('workspace', route.workspaceId);
      if (query.size) target += `?${query}`;
    }
    return `/login?returnTo=${encodeURIComponent(target)}`;
  }
  return null;
}
